import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: 2rem;
`;

const SongHistory = () => {
    return (
        <Container>
            <Title>Song History Widget Builder</Title>
            <p>Coming soon...</p>
        </Container>
    );
};

export default SongHistory; 